module.exports = __webpack_public_path__ + "img/purple.1f7bdfa2.png";